module.exports = __webpack_public_path__ + "media/images/design/icon_05-992db64ae1e35957f6228fbeab58059f.svg";